import React from 'react';
import {CSSProperties} from "react";
import {IconInfo} from "../util/IconInfo";


interface XIconProps {
    id?: string,
    icon: IconInfo,
    iconSize?: string | number,
    className?: string,
    style?: CSSProperties,
    color?: string,
    fill?: string,
    title?: string,
    onClick?: (e) => void,
    onMouseEnter?: (e) => void,
    onMouseLeave?: (e) => void,
}


interface XIconState {

}


export class XIcon extends React.Component<XIconProps, XIconState> {

    constructor(props: XIconProps) {
        super(props);
    }

    render(): React.ReactNode {
        if (this.props.icon) {
            let vb = this.props.icon.viewbox;
            let size = this.props.iconSize || 24;
            let className: string = "";
            if (this.props.className) {
                className = `${this.props.className}`;
            } else if (this.props.onClick) {
                className = "pointer";
            }
            let style = this.props.style || {};
            style["display"] = "block";
            if (this.props.fill) {
                style["fill"] = this.props.fill;
            }
            if (size) {
                style["width"] = size;
                style["height"] = size;
            }

            return (
                <svg
                    id={this.props.id}
                    className={className}
                    viewBox={`0 0 ${vb} ${vb}`}
                    style={style}
                    onClick={this.props.onClick}
                    onMouseEnter={this.props.onMouseEnter}
                    onMouseLeave={this.props.onMouseLeave}
                >
                    <title>{this.props.title}</title>
                    <path className={className} d={this.props.icon.path} fillRule="evenodd" style={style} />
                </svg>
            );
        }
    }

}
